export default class SkipLink {
    constructor() {
        this.skipLink = document.querySelector('.skip-main');
        this.mainContent = document.getElementById('main');
        if (this.skipLink && this.mainContent) {
            this.initializeSkipLink();
        }
    }
    initializeSkipLink() {
        this.skipLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.focusMainContent();
        });
    }
    focusMainContent() {
        // Get the first focusable element in main content
        const focusableElement = this.getFirstFocusableElement(this.mainContent);
        if (focusableElement) {
            focusableElement.focus();
            // Optionally scroll to element
            focusableElement.scrollIntoView({ behavior: 'smooth' });
        }
        else {
            // If no focusable element, focus the main content itself
            this.mainContent.focus();
            this.mainContent.scrollIntoView({ behavior: 'smooth' });
        }
    }
    getFirstFocusableElement(container) {
        const focusableSelectors = [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])',
        ].join(',');
        const focusableElements = container.querySelectorAll(focusableSelectors);
        // Return first visible focusable element
        for (let element of focusableElements) {
            if (element.offsetParent !== null) { // Check if element is visible
                return element;
            }
        }
        return null;
    }
}
